import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Wrapper } from './ExploreLibrary.styles';
import { AgGridReact } from '@ag-grid-community/react';
import { AllModules } from '@ag-grid-enterprise/all-modules';
import ServerSideDataSource from './ServerSideDataSource';

const ExploreLibrary = () => {
	const [columnDefs] = useState([
		{
			headerName: 'AP L1Category',
			field: 'l1',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'l1',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L2Category',
			field: 'l2',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'l2',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L3Category',
			field: 'l3',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'l3',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'AP L4Category',
			field: 'l4',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'l4',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Vendor Name',
			field: 'vENDOR_NAME',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'vENDOR_NAME',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Certification',
			field: 'certification_Name',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'certification_Name',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'State',
			field: 'state_Name',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'state_Name',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Description',
			field: 'description',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'description',
			filter: 'agTextColumnFilter',
		},
		{
			headerName: 'Contact',
			field: 'contact',
			filterParams: {
				filterOptions: [
					'contains',
					'notContains',
					'equals',
					'notEqual',
					'startsWith',
					'endsWith',
				],
			},
			colId: 'contact',
			filter: 'agTextColumnFilter',
		},
	]);

	const [gridOptions] = useState({
		modules: AllModules,
		columnDefs: columnDefs,
		cacheBlockSize: 200,
		maxBlocksInCache: 10,
		enableColResize: true,
		enableSorting: true,
		enableFilter: true,
		rowModelType: 'serverSide',
		floatingFilter: true,
		maxConcurrentDatasourceRequests: 1,
		multiSortKey: 'ctrl',
		enableRangeSelection: true,
		suppressCutToClipboard: true,
	});

	const defaultColDefs = useMemo(() => {
		return {
			flex: 1,
			minWidth: 100,
			editable: false,
		};
	}, []);
	const gridRef = useRef();

	const onGridReady = useCallback(
		params => {
			gridRef.current.api.startEditingCell(params);
			const gridOptionsnew = {
				columnDefs,
				suppressRowClickSelection: true,
				...gridOptions,
			};
			const datasource = ServerSideDataSource(
				gridOptionsnew,
				params.columnApi,
				params.api
			);
			params.api.setServerSideDatasource(datasource);
		},
		[columnDefs, gridOptions]
	);

	return (
		<Wrapper>
			<div className="ag-theme-balham">
				<AgGridReact
					ref={gridRef}
					modules={AllModules}
					columnDefs={columnDefs}
					cacheBlockSize={200}
					defaultColDef={defaultColDefs}
					maxBlocksInCache={10}
					enableColResize={true}
					enableSorting={true}
					enableFilter={true}
					enableGroupEdit={true}
					rowModelType="serverSide"
					maxConcurrentDatasourceRequests={1}
					multiSortKey="ctrl"
					onGridReady={onGridReady}
					enableRangeSelection={true}
					suppressCutToClipboard={true}
				/>
			</div>
		</Wrapper>
	);
};

export default ExploreLibrary;
